<template>
<DIV
  class="badge border"
  v-if="loaded"
>
  <ItpIcon
    icon="material-symbols:repeat-rounded"
  >
  </ItpIcon>
  <ItpText
    :text="billingFrequencyOptions[value].name"
  >
  </ItpText>
</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcBillingFrequencyDisplay extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  value!: string;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  billingFrequencyOptions!: any;

  async $$load_billingFrequencyOptions() {
    return this.$app.repo.get('ui_metadata', { path: 'billing_frequency_options', map: true, key: 'value' })
  }

  ux!: any;
  dataMembers = ['billingFrequencyOptions', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        billingFrequencyOptions: null,
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcBillingFrequencyDisplay", UcBillingFrequencyDisplay);

</script>